import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getFuncFormations = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.FUNC_FORMATION_LOADER,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Formacion/' : '/api/app/Funcional_Formacion/', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_FUNC_FORMATION,
      payload: {
        Formations: resp.data.data,
        FormationLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.FUNC_FORMATION_LOADER,
      payload: false
    });
  }
}

export const saveFuncFormations = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.FUNC_SAVE_FORMATION_LOADER,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Formacion/' : '/api/app/Funcional_Formacion/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { Formations, FormationLength } = getState().funcFormation;
    const aFormations = [...Formations, resp.data];
    dispatch({
      type: actions.GET_FUNC_FORMATION,
      payload: {
        Formations: aFormations,
        FormationLength: FormationLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.FUNC_SAVE_FORMATION_LOADER,
      payload: false
    });
  }
}

export const editFuncFormations = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.FUNC_SAVE_FORMATION_LOADER,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Formacion/${id}/` : `/api/app/Funcional_Formacion/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { Formations, FormationLength } = getState().funcFormation;
    Formations[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_FUNC_FORMATION,
      payload: {
        Formations: Formations,
        FormationLength: FormationLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.FUNC_SAVE_FORMATION_LOADER,
      payload: false
    });
  }
}

export const deleteFuncFormations = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.FUNC_FORMATION_LOADER,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Formacion/${id}/` : `/api/app/Funcional_Formacion/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { Formations, FormationLength } = getState().funcFormation;
    Formations.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_FUNC_FORMATION,
      payload: {
        Formations: Formations,
        FormationLength: FormationLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.FUNC_FORMATION_LOADER,
      payload: false
    });
  }
}
